(function($) {

	$.fn.initMuseumHomepage = function() {

		var _this = this;

		_this.addClass("preparing").each(function() {
			var $this = $(this);
			$this.waypoint(
				function() {
					$this.removeClass("preparing");
				},
				{
					offset: function() {
						return Waypoint.viewportHeight() - 200;
					}
				}
			);
		});

		window.setTimeout(function() {
			_this.addClass("animated");
		}, 50);

		return this;

	}

})(jQuery);
